import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OdooSyncService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private getHeaders() {
    const token = localStorage.getItem('token');
    return new HttpHeaders().set('Authorization', `Bearer ${token}`);
  }

  // // Trae una orden específica junto con sus materiales vinculados
  // getOrdenCompleta(documentId: string) {
  //   const token = localStorage.getItem('jwt');
  //   let headers = new HttpHeaders();
  //   if (token) {
  //     headers = headers.set('Authorization', `Bearer ${token}`);
  //   }
  //   return this.http.get(`${this.apiUrl}/orden-operativas/${documentId}?populate=*`, { headers });
  // }


  crearMaterial(materialData: any) {
    // Usamos la misma función de cabeceras para garantizar que el token vaya correcto
    const headers = this.getHeaders();
    return this.http.post(`${this.apiUrl}/material-ordens`, { data: materialData }, { headers });
  }

  // Obtiene todas las órdenes asociadas al ID del técnico
  getOrdenesPorTecnico(tecnicoId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/orden-operativas?filters[tecnico][id][$eq]=${tecnicoId}&populate=*`, {
      headers: this.getHeaders()
    });
  }

  // Obtiene el detalle de una sola orden usando el documentId (Strapi v5)
  getOrdenDetalle(documentId: string): Observable<any> {
    // Al agregar ?populate=* le decimos a Strapi que también traiga los materiales vinculados
    return this.http.get(`${this.apiUrl}/orden-operativas/${documentId}?populate=*`, {
      headers: this.getHeaders()
    });
  }

  // Actualiza los campos de la orden mediante PUT envueltos en el objeto "data"
  actualizarOrden(documentId: string, datosReporte: any): Observable<any> {
    const body = {
      data: datosReporte
    };
    return this.http.put(`${this.apiUrl}/orden-operativas/${documentId}`, body, {
      headers: this.getHeaders()
    });
  }

  // Reemplaza o asegura que tu método acepte el formato plano o FormData
  actualizarOrdenConArchivos(documentId: string, formData: FormData) {
  const token = localStorage.getItem('token');
  
  // Fíjate que SOLO enviamos el Authorization. 
  // Angular automáticamente pondrá el Content-Type correcto (multipart/form-data)
  // y el 'boundary' necesario. ¡No le agregues Content-Type!
  const headers = new HttpHeaders({
    'Authorization': `Bearer ${token}`
  });
  
  return this.http.put(`${this.apiUrl}/orden-operativas/${documentId}`, formData, { headers });
}

  // Sube un archivo puro a la librería de Strapi
  subirArchivo(archivoBlob: Blob, nombreArchivo: string): Observable<any> {
    const formData = new FormData();
    formData.append('files', archivoBlob, nombreArchivo);

    // 👇 AQUÍ ESTÁ LA MAGIA: Usamos 'token' porque así lo guarda tu login
    const token = localStorage.getItem('token'); 
    
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    
    return this.http.post(`${this.apiUrl}/upload`, formData, { headers });
  }

  // ==========================================
  // FUNCIONES DE USUARIOS Y ROLES (STRAPI)
  // ==========================================
  
  getUsuariosRoles(): Observable<any> {
    const headers = this.getHeaders();
    // En Strapi, los roles están en este endpoint
    return this.http.get(`${this.apiUrl}/users-permissions/roles`, { headers });
  }

  getTodosLosUsuarios(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.apiUrl}/users?populate=role`, { headers });
  }

  crearUsuario(datosUsuario: any): Observable<any> {
    const headers = this.getHeaders();
    // Para crear un usuario directo en Strapi
    return this.http.post(`${this.apiUrl}/users`, datosUsuario, { headers });
  }

  actualizarUsuario(id: number, datosUsuario: any): Observable<any> {
    const headers = this.getHeaders();
    return this.http.put(`${this.apiUrl}/users/${id}`, datosUsuario, { headers });
  }

  eliminarUsuario(id: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(`${this.apiUrl}/users/${id}`, { headers });
  }

  // Obtiene las órdenes creadas por un vendedor específico, ordenadas por las más recientes
  getOrdenesPorVendedor(vendedorId: number): Observable<any> {
    const headers = this.getHeaders();
    // Asumiendo que tienes una relación 'vendedor' en Strapi
    return this.http.get(`${this.apiUrl}/orden-operativas?filters[vendedor][id][$eq]=${vendedorId}&sort=createdAt:desc&populate=*`, { headers });
  }

// Crea una nueva orden en Strapi
  crearOrden(datosOrden: any): Observable<any> {
    const headers = this.getHeaders();
    
    // Al igual que el PUT, Strapi v5 exige que envolvamos los datos en la llave "data"
    const body = {
      data: datosOrden
    };

    return this.http.post(`${this.apiUrl}/orden-operativas`, body, { headers });
  }

  // Obtiene la lista de todos los técnicos registrados
  getTecnicos(): Observable<any> {
    const headers = this.getHeaders();
    // Filtramos por el nombre del rol 'Tecnico' (asegúrate que así se llame en tu Strapi)
    return this.http.get(`${this.apiUrl}/users?filters[role][name][$eq]=Tecnico`, { headers });
  }


  // Obtiene TODAS las órdenes del sistema (Para el Admin)
  getTodasLasOrdenes(): Observable<any> {
    const headers = this.getHeaders();
    // Traemos todo y lo ordenamos de lo más nuevo a lo más viejo
    return this.http.get(`${this.apiUrl}/orden-operativas?populate=*&sort=createdAt:desc`, { headers });
  }

  // Elimina una orden por completo (Solo Admin)
  eliminarOrden(documentId: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.delete(`${this.apiUrl}/orden-operativas/${documentId}`, { headers });
  }


  // Obtiene las órdenes agendadas con crearOrden relaciones para preparar materiales
  getOrdenesPendientesAlmacen(): Observable<any> {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    // Traemos las órdenes que están agendadas, junto con sus materiales y el técnico asignado
    return this.http.get(`${this.apiUrl}/orden-operativas?filters[estado][$eq]=agendada&populate=*`, { headers });
  }

  // Sube una imagen en Base64 a Strapi y la asocia a un campo específico
  subirArchivoBase64(base64String: string, nombreArchivo: string, refId: string, ref: string, field: string): Observable<any> {
    const token = localStorage.getItem('token');
    
    // 1. Convertimos el Base64 a un Blob real
    const byteString = atob(base64String.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: 'image/jpeg' });

    // 2. Preparamos el formulario (FormData) como lo pide Strapi
    const formData = new FormData();
    formData.append('files', blob, nombreArchivo);
    
    // Le decimos a Strapi a dónde pertenece esta foto
    formData.append('refId', refId);        // ID de la orden
    formData.append('ref', ref);            // Nombre de la colección (ej. api::orden-operativa.orden-operativa)
    formData.append('field', field);        // Nombre del campo (foto_credencial)

    // 3. Enviamos SOLO el Authorization. Angular pone el multipart boundary.
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    
    return this.http.post(`${this.apiUrl}/upload`, formData, { headers });
  }

  // Actualiza la cantidad real usada de un material específico
  actualizarMaterialOrden(documentId: string, datosMaterial: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.put(`${this.apiUrl}/material-ordens/${documentId}`, { data: datosMaterial }, { headers });
  }

  // Crea el registro oficial de la visita física
  crearVisita(datosVisita: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${this.apiUrl}/visitas`, { data: datosVisita }, { headers });
  }

  // Obtiene el texto legal para el contrato en PDF
  // Obtiene el texto legal para el contrato en PDF
  getPlantillaContrato(): Observable<any> {
    const headers = this.getHeaders();
    // 👇 Aquí está la magia: usamos el nombre exacto que le dio Strapi
    return this.http.get(`${this.apiUrl}/plantilla-contratoes?pagination[limit]=1`, { headers });
  }


  // Crea el registro de un nuevo recobro/cargo extra
  crearRecobro(datosRecobro: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // Ojo: 'orden_operativas' (plural) porque así aparece en tu Strapi
    return this.http.post(`${this.apiUrl}/recobros`, { data: datosRecobro }, { headers });
  }

  // ==========================================
  // FUNCIONES PARA VISITAS DE COTIZACIÓN
  // ==========================================

  // Crea el registro de una visita de cotización (Antes de la venta)
  crearVisitaCotizacion(datosVisita: any): Observable<any> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post(`${this.apiUrl}/visita-cotizacions`, { data: datosVisita }, { headers });
  }

  // Obtiene el detalle de una visita de cotización
  getVisitaCotizacionDetalle(documentId: string): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.apiUrl}/visita-cotizacions/${documentId}?populate=*`, { headers });
  }

  // Obtiene TODAS las visitas de cotización
  getTodasLasVisitasCotizacion(): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.apiUrl}/visita-cotizacions?populate=*&sort=createdAt:desc`, { headers });
  }

  // Obtiene solo las visitas de cotización de un técnico
  getVisitasCotizacionPorTecnico(tecnicoId: number): Observable<any> {
    const headers = this.getHeaders();
    return this.http.get(`${this.apiUrl}/visita-cotizacions?filters[tecnico][id][$eq]=${tecnicoId}&populate=*&sort=createdAt:desc`, { headers });
  }

  // Actualiza el estado de una orden al iniciar trabajo
  actualizarEstadoOrden(documentId: string, nuevoEstado: string): Observable<any> {
    const headers = this.getHeaders();
    const body = {
      data: {
        estado: nuevoEstado
      }
    };
    return this.http.put(`${this.apiUrl}/orden-operativas/${documentId}`, body, { headers });
  }

}